import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppShell, useDarkMode } from '@pazportal/ui';
import { useAuth } from '../contexts/AuthContext';
import { navSections, PORTAL_COLOR, PORTAL_NAME, PORTAL_SUBTITLE } from '../config/navigation';
import { useEstimateMetrics } from '../hooks/useEstimateMetrics';
import { humanizeRole, initialsFromName, useCurrentProfile } from '../hooks/useCurrentProfile';

export function AppLayout() {
  const { user, role, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { isDark, toggle } = useDarkMode();
  const { data: metrics } = useEstimateMetrics();
  const { data: profile } = useCurrentProfile();

  const email = profile?.email ?? user?.email ?? '';
  const displayName = profile?.full_name?.trim() || email || 'Signed in';
  const displayRole = humanizeRole(profile?.role ?? role);
  const initials = initialsFromName(
    profile?.full_name,
    email ? email.slice(0, 2).toUpperCase() : '??',
  );

  const activeCount = metrics ? metrics.inProgress + metrics.sent : null;
  const pipelineSubtitle =
    activeCount === null
      ? 'Estimates'
      : `${activeCount} open estimate${activeCount === 1 ? '' : 's'}`;

  return (
    <AppShell
      navSections={navSections}
      portalColor={PORTAL_COLOR}
      portalName={PORTAL_NAME}
      portalSubtitle={PORTAL_SUBTITLE}
      propertyName={PORTAL_NAME}
      propertySubtitle={pipelineSubtitle}
      propertyInitials="PN"
      userName={displayName}
      userRole={displayRole}
      userInitials={initials}
      currentPath={location.pathname}
      onNavigate={(href: string) => navigate(href)}
      onSignOut={signOut}
      onDarkModeToggle={toggle}
      isDarkMode={isDark}
    >
      <Outlet />
    </AppShell>
  );
}
